<div class="col-md-12">
  <div class="col-lg-10 nopadding">
    <app-filter-panel [isAddFilter]=false [DefaultFilterArray]="DefaultFilterArray"
      (FilterEvent)="FilterApplyFilterEvent($event)"
      [isDatefilterDropdown]="true">
    </app-filter-panel>
  </div>
  <br/>
  <div class="col-lg-12 nopadding">
    <div class="ui-widget-header-1 nopadding">
      <div class="ui-grid-col-12 btnPanel">
        <label for="ByVenueBtn">
          <button pButton id="ByVenueBtn" type="button" [disabled]="false" [ngClass]="(selectedTabIndex === 1 ? 'optedBtnColor' : '')" label="By Venue" (click)="getOptedTab(1, 'ByVenue')" class="button btn-lg p-button-text innerScreenTabBtn"></button>
        </label>
        <label for="MonthBtn">
          <button pButton id="MonthBtn" type="button" [disabled]="false" [ngClass]="(selectedTabIndex === 2 ? 'optedBtnColor' : '')" label="Month" (click)="getOptedTab(2, 'Month')" class="button btn-lg p-button-text innerScreenTabBtn"></button>
        </label>
      </div>
    </div>
  </div>
</div>
<br/>
<!-- Venue Tab -->
  <div class="col-lg-12 nopadding" [ngClass]="(!venueTab ? 'notdisplay': '')">
    <div class="ui-g">
      <!-- Display Venue Summary and Bar Graph -->
        <div class="ui-g-12 ui-md-6 ui-lg-9">
          @if(venueGraphDataLoadingResults){
          <div class="example-loading-shade">
            @if(venueGraphDataLoadingResults){
            <mat-spinner diameter="50"></mat-spinner>}
          </div>}
          <!-- Summary -->
            <div class="ui-g border venueSummary">
              <div class="ui-g-6 border nopadding">
                  <div class="ui-g-6 border-right bold-text">Total Billing Shares</div>
                  <div class="ui-g-6 text-right bold-text">{{ (venueSummaryDetail && venueSummaryDetail.totalBillingShares ? venueSummaryDetail.totalBillingShares : 0) | number }}</div>
              </div>
              <div class="ui-g-6 border nopadding">
                <div class="ui-g-6 border-right bold-text">Estimated Bill</div>
                <div class="ui-g-6 text-right bold-text">{{ (venueSummaryDetail && venueSummaryDetail.totalBillingAmount ? venueSummaryDetail.totalBillingAmount : 0) | currency }}</div>
              </div>
            </div>
          <!-- End of Summary -->
           @if(venueChartLabels.length > 0){
          <div class="chart chartBlock" [style.height.px]="getGraphChartHeight()">
            <canvas baseChart [type]="'bar'"  
              [data]="venueChartData" [options]="venueChartOptions"
              [labels]="venueChartLabels">
            </canvas>
          </div>}
        </div>
      <!-- End of Display Venue Summary and Bar Graph -->
      <!-- Execution Venue List -->
        <div class="ui-g-12 ui-md-6 ui-lg-3">
          <p-table emptyMessage="tbldatamsg" appendTo="body" [value]="executionVenues" [columns]="venueTabularColumns" [scrollable]="true" scrollHeight="420px">
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td class="text-center" [attr.colspan]="columns.length">
                  {{tbldatamsg}}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="colgroup" let-columns>
              <colgroup>
                @for (col of columns; track col;){
                <col class="cellHeight">}
              </colgroup>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
              <tr>
                @for (col of columns; track col;){
                <th>
                  {{col.header}}
                </th>}
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-executionVenue>
                <tr>
                    <td>{{executionVenue.executionvenue}}</td>
                    <td class="text-right">{{executionVenue.billingshares}}</td>
                </tr>
            </ng-template>
          </p-table>
        </div>
      <!-- End of Execution Venue List -->
    </div>
  </div>
<!-- End of Venue Tab -->
<!-- Monthly Tab -->
  <div class="col-lg-12 nopadding" [ngClass]="(!monthTab ? 'notdisplay': '')">
    <div class="ui-g">
      <!-- Display monthly Summary and Bar/Line Combination Graph -->
        <div class="ui-g-12 ui-md-6 ui-lg-12">
          @if(monthlyGraphDataLoadingResults){
          <div class="example-loading-shade">
            @if(monthlyGraphDataLoadingResults){
            <mat-spinner diameter="50"></mat-spinner>}
          </div>}
          <!-- Summary -->
            <div class="ui-g border monthlySummary">
              <div class="ui-g-3 border nopadding">
                <div class="ui-g-6 border-right bold-text text-center">Month</div>
                <div class="ui-g-6 text-center bold-text monthText">{{ reportDate | date:"MMMM" }}</div>
              </div>
              <div class="ui-g-3 border nopadding">
                  <div class="ui-g-6 border-right bold-text">Total Billing Shares</div>
                  <div class="ui-g-6 text-right bold-text">{{ (monthlySummaryDetail && monthlySummaryDetail.totalBillingShares ? monthlySummaryDetail.totalBillingShares : 0) | number }}</div>
              </div>
              <div class="ui-g-3 border nopadding">
                <div class="ui-g-7 border-right bold-text">Average Daily Shares</div>
                <div class="ui-g-5 text-right bold-text">{{ (monthlySummaryDetail && monthlySummaryDetail.monthlyAverageBillingShares ? monthlySummaryDetail.monthlyAverageBillingShares : 0) | number }}</div>
              </div>
              <div class="ui-g-3 border nopadding">
                <div class="ui-g-7 border-right bold-text">Estimated Bill</div>
                <div class="ui-g-5 text-right bold-text">{{ (monthlySummaryDetail && monthlySummaryDetail.totalBillingAmount ? monthlySummaryDetail.totalBillingAmount : 0) | currency }}</div>
              </div>
            </div>
          <!-- End of Summary -->
           @if(monthlyChartLabels.length > 0){
          <div class="chart chartBlock" [style.height.px]="getGraphChartHeight()">
            <canvas baseChart [type]="'bar'"
              [data]="chartData" [options]="monthlyChartOptions"
              [labels]="monthlyChartLabels">
            </canvas>
          </div>}
        </div>
      <!-- Display monthly Summary and Bar/Line Combination Graph -->
    </div>
  </div>
<!-- End of Monthly Tab -->